import { render, staticRenderFns } from "./DynamicPricingPercentageDiscountTable.vue?vue&type=template&id=18768854&scoped=true"
import script from "./DynamicPricingPercentageDiscountTable.vue?vue&type=script&lang=js"
export * from "./DynamicPricingPercentageDiscountTable.vue?vue&type=script&lang=js"
import style0 from "./DynamicPricingPercentageDiscountTable.vue?vue&type=style&index=0&id=18768854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18768854",
  null
  
)

export default component.exports